// extracted by mini-css-extract-plugin
export default {"premium-folder-icon":"_2-YRy","premiumFolderIcon":"_2-YRy"};